const types = {
    SET_CASE_TAGS: "SET_CASE_TAGS",
    ADD_CASE_TAG: "ADD_CASE_TAG",
    REMOVE_CASE_TAG: "REMOVE_CASE_TAG"
  };
  
  export default types;
  